var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.inSwitch)?_c('div',{},[_c('Sidebar')],1):_c('div',{},[_c('SidebarAdmin')],1),_c('div',{staticClass:"home_content",attrs:{"id":"home_content"}},[_c('div',{staticClass:"overlay",attrs:{"id":"overlay"},on:{"click":_vm.closeSibebarMobile}}),(!_vm.inSwitch)?_c('Header'):_c('HeaderAdmin'),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }